/**
 * Vee-Validate
 * Config
 *
 * @since: 2018-03-24
 * @author: kdydesign.kim
 *
 */
import Ko from '~/static/locales/ko/validate_ko.json'
import En from '~/static/locales/en/validate_en.json'

// 커스텀 메세지 (TAMS)
const dictionary = {
  ko: {
    messages: Ko
  },
  en: {
    messages: En
  }
}

const config = {
  locale: 'ko',
  dictionary,
  fieldsBagName: 'validateFields'
}

export default config
